var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview__wrapper"},[_c('h3',[_vm._v("Preview")]),_c('div',{staticClass:"test_model",style:({
      color: _vm.textColor,
      backgroundColor: _vm.backgroundColor,
      borderStyle: _vm.borderStyle,
      borderColor: _vm.borderColor,
      borderWidth: `${_vm.borderWidth}px`,
      borderRadius: `${_vm.borderRadius}px`
    })},[_c('span',{class:[_vm.isSectionVisible ? 'title__template' : 'hidden__section']},[(!_vm.isSectionVisible)?_c('font-awesome-icon',{staticClass:"text-warning mr-1",attrs:{"icon":['fas', 'eye-slash']}}):_vm._e(),_vm._v(" "+_vm._s(_vm.sectionName)+" ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }